var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticStyle:{"margin-right":"2px"},attrs:{"src":"/images/payment/visa.png"}}),_c('img',{attrs:{"src":"/images/payment/mastercard.png"}})])
}]

export { render, staticRenderFns }